import AOS from 'aos';
/*import {
	Fancybox,
	Carousel,
	Panzoom
} from "@fancyapps/ui"; */
import {
	Fancybox
} from "@fancyapps/ui";

import { Loader } from "@googlemaps/js-api-loader";
exports.loader = new Loader({
	apiKey: "AIzaSyBGpDz1s01B81TZDqTMNnjDMX4xjk28Cws",
	version: "weekly",
});

import StickySidebar from 'sticky-sidebar';
import Sticky from 'sticky-js';
var sticky = new Sticky('[data-sticky]', {});

import Swiper from 'swiper/bundle';
exports.swiper = Swiper;

import ouibounce from 'ouibounce';

import Player from '@vimeo/player';
window.Player = Player;

Fancybox.bind("[data-fancybox]", {
	hideScrollbar: true,
});

function setCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}

	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}

	return null;
}

function eraseCookie(name) {
	document.cookie = name + '=; Max-Age=-99999999;';
}

function initExitIntentScript() {
	jQuery(function ($) {
		//var modalSelector = '#mc-popup';
		//var cookieName = 'modalClosed';
		var modalSelector = '#reg-popup';
		var cookieName = 'RegModalClosed';
	
		if ($(modalSelector).length) {
			var modalClosed = getCookie(cookieName);
			if (modalClosed) {
				return false;
			}

			var visits = getCookie('visits') ? parseInt(getCookie('visits')) : 0;
			var session = getCookie('session');
	
			if (!session) {
				visits++;
				setCookie('visits', visits, 30); // Increment visit count for new session
				setCookie('session', 'active'); // Set session cookie that expires when browser is closed
			}
	
			if (visits <= 2 && !modalClosed) {
				ouibounce(document.querySelector(modalSelector), {
					aggressive: true,
					cookieExpire: 0, // Disable ouibounce cookie
					cookieName: '',  // Disable ouibounce cookie
					callback: function () {
						$(modalSelector).modal('show');
					}
				});
	
				$(modalSelector).on('hide.bs.modal', function () {
					setCookie(cookieName, true, 3);
					eraseCookie('visits');
					eraseCookie('session');
				});
			}
		}
	});
}

function checkIubendaConsent() {
	console.log('checking consent...');

	console.log(_iub.cs.api.isConsentGiven());
	if (typeof _iub !== 'undefined' && _iub.cs && _iub.cs.api && _iub.cs.api.isConsentGiven()) {
		initExitIntentScript();
	}
}

function waitForIubenda(callback, attempts = 5) {
	if (typeof _iub !== 'undefined' && _iub.cs && _iub.cs.api) {
		callback();
	} else if (attempts > 0) {
		setTimeout(function () {
			waitForIubenda(callback, attempts - 1);
		}, 1000); // Check every 1 second
	}
}

jQuery(function ($) {
	// Show or hide the "scroll to top" button based on scroll position with smooth fade in/out
	$(window).scroll(function () {
		if ($(this).scrollTop() > 0 && !($('body').hasClass('footer-visible'))) {
			$('#scrollToTopBtn').fadeIn();
		} else {
			$('#scrollToTopBtn').fadeOut();
		}
	});

	$(document).on('click', '#scrollToTopBtn', scrollToTop);

	function scrollToTop() {
		$('html, body').animate({ scrollTop: 0 }, 800);
	}

	$(document).on('change', 'input[name="category"]', function () {
		$(this).closest('form').trigger('submit');
	})

	$('#filter-form').on('submit', function (event) {
		event.preventDefault();
		var formData = $(this).serialize();

		$.ajax({
			url: jscottAjax.ajaxurl, // The WordPress AJAX handler
			data: formData,
			dataType: 'json',
			type: 'POST',
			beforeSend: function () {
				$('#jscott_posts_wrap').addClass('loading');
			},
			success: function (data) {
				// when filter applied:
				// set the current page to 1
				jscottAjax.current_page = 1;

				// set the new query parameters
				jscottAjax.posts = data.posts;

				// set the new max page parameter
				jscottAjax.max_page = data.max_page;

				$('#jscott_posts_wrap').removeClass('loading').html(data.content);
				// hide load more button, if there are not enough posts for the second page
				if (data.max_page < 2) {
					$('#jscott_loadmore').hide();
				} else {
					$('#jscott_loadmore').show();
				}
			},
			error: function (xhr, status, error) {
				$('#jscott_posts_wrap').html('<p>Error occurred. Please try again later.</p>');
				console.log(xhr.responseText);
			}
		});
	});

	/*
	 * Load More
	 */
	$('#jscott_loadmore').click(function () {
		$.ajax({
			url: jscottAjax.ajaxurl, // AJAX handler
			data: {
				'action': 'loadmorebutton', // the parameter for admin-ajax.php
				'query': jscottAjax.posts, // loop parameters passed by wp_localize_script()
				'page': jscottAjax.current_page // current page
			},
			type: 'POST',
			beforeSend: function (xhr) {
				$('#jscott_loadmore').text('Loading...'); // some type of preloader
			},
			success: function (posts) {
				if (posts) {
					//console.log(posts);
					$('#jscott_loadmore').text('More posts');
					$('#jscott_posts_wrap').append(posts); // insert new posts
					jscottAjax.current_page++;

					if (jscottAjax.current_page == jscottAjax.max_page)
						$('#jscott_loadmore').hide(); // if last page, HIDE the button
				} else {
					$('#jscott_loadmore').hide(); // if no data, HIDE the button as well
				}
			}
		});
		return false;
	});

	$('svg[data-control]').on('click', function () {
		const targetID = $(this).data('controls'),
			target = $('#' + targetID),
			direction = $(this).data('control');

		if (direction == 'next') {
			target[0].swiper.slideNext();
		} else if (direction == 'previous') {
			target[0].swiper.slidePrev();
		}
	});

	$('#mc-signup, #mc-signup-f').on('submit', function (e) {
		e.preventDefault();
		{
			var form = $(this),
				button = form.find($('button[type="submit"]')),
				data = {
					action: 'mc_subscribe',
					nonce: jscottAjax.ajax_nonce,
					data: form.serialize(),
				};

			$.ajax({
				type: "post",
				dataType: "json",
				url: jscottAjax.ajaxurl,
				data: data,
				beforeSend: function () {
					button.attr('disabled', true);
					form.addClass('loading');
				},
				success: function (response) {
					if (form.attr('id') == 'mc-signup') {
						form.closest('.modal-body').html(response['html']);
					} else if (form.attr('id') == 'mc-signup-f') {
						form.parent().html(response['html']);
					}
				}
			})
		};
	})
});

document.addEventListener("DOMContentLoaded", function () {
	AOS.init({
		once: true,
		duration: 800, // values from 0 to 3000, with step 50ms
		easing: 'ease-in-out',
		initClassName: false,
		offset: 200
	});
	waitForIubenda(checkIubendaConsent);
	
	// Get the header element
	const header = document.querySelector("#wrapper-navbar");
	const toggleClass = "sticky";

	window.addEventListener("scroll", () => {
		const currentScroll = window.pageYOffset;
		if (currentScroll > 0) {
			header.classList.add(toggleClass);
		} else {
			header.classList.remove(toggleClass);
		}
	});

	if (document.querySelector('#jscott-products-filter')) {
		function getTopSpacing() {
			const navbarHeight = document.querySelector('#wrapper-navbar') ? document.querySelector('#wrapper-navbar').offsetHeight : 0;
			const bannerHeight = document.querySelector('#top-offer-banner') ? document.querySelector('#top-offer-banner').offsetHeight : 0;
			return navbarHeight + bannerHeight + 16;
		}

		let sidebar = new StickySidebar('#jscott-products-filter', {
			containerSelector: '#jscott-products-archive',
			innerWrapperSelector: '#jscott-products-filter-wrapper',
			topSpacing: getTopSpacing(),
			bottomSpacing: 20,
			minWidth: 991
		});

		let resizeTimer;
		const resizeObserver = new ResizeObserver(entries => {
			clearTimeout(resizeTimer);

			// Set a new timeout
			resizeTimer = setTimeout(() => {
				sidebar.updateSticky();
			}, 1000);
		});

		// Start observing a DOM node
		resizeObserver.observe(document.querySelector('#jscott-products-filter-inner'));

		// Update the topSpacing when the window is resized
		window.addEventListener('resize', () => {
			sidebar.options.topSpacing = getTopSpacing();
			sidebar.updateSticky();
		});

		jQuery(document).on('woof_ajax_done', function () {
			sidebar.updateSticky();
		});
	}

	function handleIntersection(entries) {
		let isInViewport = false;

		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				isInViewport = true;
			}
		});

		if (isInViewport) {
			document.body.classList.add('footer-visible');
		} else {
			document.body.classList.remove('footer-visible');
		}
	}

	if (document.querySelector('#scrollToTopBtn')) {
		const targetElement = document.querySelector('#wrapper-footer');
		const observer = new IntersectionObserver(handleIntersection);
		observer.observe(targetElement);
	}
});
